// Mock data for ETAN LLC Website

export const services = [
  {
    id: 1,
    title: "Marketing Strategy",
    description: "Development of structured marketing plans based on market analysis, target audience identification, and business objectives.",
    icon: "LineChart"
  },
  {
    id: 2,
    title: "Digital Marketing & Growth",
    description: "Execution of targeted campaigns focused on customer acquisition, performance tracking, and continuous optimization.",
    icon: "TrendingUp"
  },
  {
    id: 3,
    title: "Business Consulting",
    description: "Advisory services to improve business positioning, operational efficiency, and sustainable growth strategies.",
    icon: "Briefcase"
  },
  {
    id: 4,
    title: "Brand Development",
    description: "Creation and refinement of brand identity to strengthen market presence and ensure consistent communication.",
    icon: "Award"
  }
];

export const whyChooseUs = [
  {
    title: "Data-Driven Approach",
    description: "All strategies are based on thorough market analysis and measurable performance indicators."
  },
  {
    title: "International Experience",
    description: "Proven experience working with clients across the European Union and international markets."
  },
  {
    title: "Cross-Border Expertise",
    description: "Understanding of regulatory environments and business practices across different jurisdictions."
  },
  {
    title: "Professional Standards",
    description: "Commitment to confidentiality, transparency, and long-term client relationships."
  }
];

// Contact form submission handler (mock)
export const submitContactForm = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Form submitted:", formData);
      resolve({ success: true, message: "Thank you for your inquiry. We will respond within 24 hours." });
    }, 1000);
  });
};
